import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, Image, Button, useToast, Grid } from '@chakra-ui/react';
import { useLazyGetStoreItemsQuery, useTradeStoreItemMutation } from 'store/services/api';
import { useLazyGetUserProfileQuery } from 'store/services/users';
import { pageview } from 'utils/analytics';
import routes from 'constants/routes';
import Preloader from 'components/Preloader';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, setUser } from 'store/slices/authSlice';
import { useNavigate } from 'react-router';
import TradeConfirmationModal from 'components/store/TradeConfirmationModal';

const StorePage = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const [getStoreItem, { data: storeItems, isLoading, isSuccess }] = useLazyGetStoreItemsQuery();
  const [
    tradeStoreItem,
    { data: tradeResponseData, isSuccess: isTradeSuccess, isLoading: isTradeLoading, error: tradeError },
  ] = useTradeStoreItemMutation();
  const [getUserProfile, { data: updatedUser, isSuccess: isUserUpdateSuccesfully }] = useLazyGetUserProfileQuery();
  const toast = useToast();
  const dispatch = useDispatch();
  const [processingItemId, setProcessingItemId] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [processingItem, setProcessingItem] = useState(null);

  useEffect(() => {
    getStoreItem();
    pageview(routes.trade);
  }, [getStoreItem]);

  useEffect(() => {
    if (isTradeSuccess && processingItem) {
      const successMessage = tradeResponseData?.message || 'Trade successful!';
      toast({
        duration: 3000,
        isClosable: true,
        position: 'top',
        render: ({ onClose }) => {
          return (
            <Flex
              alignItems="center"
              justifyContent="center"
              p="5px 18px !important"
              backgroundColor="#111111"
              borderRadius="10px"
              gap="10px"
              w="min-content"
              whiteSpace="nowrap"
              margin="0 auto 10px"
              fontSize="14px"
              fontWeight="600"
              onClick={onClose}
            >
              <Box>{successMessage}</Box>
            </Flex>
          );
        },
      });
      getStoreItem();
      getUserProfile();

      setProcessingItemId(null);
      setProcessingItem(null); // Очищаем состояние после завершения

      if (tradeResponseData?.redirect_url) {
        window.open(tradeResponseData.redirect_url + `?prize=${processingItem?.title}`, '_blank');
      }
    }
  }, [isTradeSuccess, toast, getUserProfile, processingItem, getStoreItem, tradeResponseData]);

  useEffect(() => {
    if (isUserUpdateSuccesfully) {
      dispatch(setUser(updatedUser));
    }
  }, [isUserUpdateSuccesfully, updatedUser, dispatch]);
  useEffect(() => {
    if (tradeError) {
      const errorMessage = tradeError?.data.message || 'Trade failed. Please try again.';
      toast({
        duration: 3000,
        isClosable: true,
        position: 'top',
        render: ({ onClose }) => {
          return (
            <Flex
              alignItems="center"
              justifyContent="center"
              p="5px 18px !important"
              backgroundColor="#111111"
              borderRadius="10px"
              gap="10px"
              w="min-content"
              whiteSpace="nowrap"
              margin="0 auto 10px"
              fontSize="14px"
              fontWeight="600"
              onClick={onClose}
            >
              <Box>{errorMessage}</Box>
            </Flex>
          );
        },
      });
      setProcessingItemId(null);
      setProcessingItem(null); // Очищаем состояние при ошибке
    }
  }, [tradeError, toast]);

  const onTradeClickHandler = item => {
    setSelectedItem(item);
    setShowConfirmModal(true);
  };

  const handleConfirmTrade = () => {
    if (selectedItem) {
      setProcessingItemId(selectedItem.id);
      setProcessingItem(selectedItem); // Сохраняем предмет для дальнейшего использования
      tradeStoreItem({ item_id: selectedItem.id })
        .unwrap()
        .catch(error => {
          console.error('Trade error caught:', error);
        });
    }
    setShowConfirmModal(false);
    setSelectedItem(null);
  };

  const handleCancelTrade = () => {
    setShowConfirmModal(false);
    setSelectedItem(null);
  };

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" gap="10px">
      <Text
        fontWeight="400"
        fontSize="24px"
        align="center"
        color="white"
        fontFamily="Fugaz One"
        lineHeight="1.1"
        mb="32px"
      >
        EARN COINS AND TRADE THEM
      </Text>
      {/* <Text fontWeight="700" fontSize="16px" align="center" color="white" lineHeight="1.2" mb="33px">
        Exclusive stuff
        <br />2 lines of text
      </Text> */}

      {isLoading && <Preloader />}
      <Grid
        flexDirection="column"
        w="100%"
        gap="30px 20px"
        gridTemplateColumns="1fr 1fr"
        gridTemplateRows={'repeat(2, 1fr)'}
      >
        {isSuccess &&
          [...storeItems]
            .sort((a, b) => a?.order - b?.order)
            .map((item, i) => (
              <Flex
                key={`${item.id}_${i}`}
                flexDirection="column"
                alignItems="center"
                justifyContent="flex-start"
                gap="16px"
                w="100%"
              >
                <Box
                  backgroundImage={`url(${item.image})`}
                  backgroundPosition="center center"
                  backgroundSize="cover"
                  width="100%"
                  aspectRatio="1/1"
                  borderRadius="12px"
                  position="relative"
                  display="flex"
                  textTransform="uppercase"
                  fontWeight="400"
                  fontSize="16px"
                  align="center"
                  color="white"
                  fontFamily="Fugaz One"
                  lineHeight="1"
                  overflow="hidden"
                  backgroundColor="rgba(255, 255, 255, 0.1)"
                >
                  {/* {item.quantity > 0 && !item.is_sold_out && (
                  <Box
                    position="absolute"
                    backgroundColor="rgba(255, 1, 200, 1)"
                    p="9px 10px 8px"
                    top="13px"
                    left="0px"
                  >
                    {item.quantity} PIECE DROP
                  </Box>
                )} */}

                  {item.is_sold_out && (
                    <Box
                      position="absolute"
                      backgroundColor="rgba(255, 255, 0, 1)"
                      p="9px 10px 8px"
                      bottom="80px"
                      transform="rotate(-23deg) translateX(-50%)"
                      left="50%"
                      color="black"
                      fontFamily="Manrope"
                      fontWeight="700"
                      width="150%"
                      letterSpacing="0.03em"
                    >
                      SOLD OUT SOLD OUT SOLD
                    </Box>
                  )}
                </Box>
                <Flex flexDirection="column" gap="5px" w="100%">
                  <Text
                    textTransform="uppercase"
                    fontWeight="400"
                    fontSize="16px"
                    align="center"
                    color="white"
                    fontFamily="Fugaz One"
                    lineHeight="1.4"
                    textAlign="left"
                    w="100%"
                  >
                    {item.title}
                  </Text>
                  <Flex gap="4px" w="100%">
                    <Image
                      src="/images/coin.png"
                      alt="coin"
                      w="16px"
                      h="16px"
                      objectFit="contain"
                      objectPosition="center"
                    />
                    <Text
                      textTransform="uppercase"
                      fontWeight="400"
                      fontSize="16px"
                      align="center"
                      color="white"
                      fontFamily="Fugaz One"
                      lineHeight="1.1"
                      textAlign="left"
                      w="100%"
                    >
                      {item.coins_value}
                    </Text>
                  </Flex>
                </Flex>

                <Flex justifyContent="flex-start" alignItems="flex-end" w="100%" flex="1">
                  <Button
                    isLoading={isTradeLoading && processingItemId === item.id}
                    isDisabled={isTradeLoading || item.is_sold_out}
                    h="40px"
                    w="auto"
                    px="20px"
                    variant="blue"
                    onClick={() => {
                      if (user?.current_amount < item.coins_value) {
                        navigate(routes.rewards);
                      }

                      if (item.is_sold_out) {
                        return;
                      }
                      if (item.quantity === 0) {
                        return;
                      }
                      if (item.quantity > 0) {
                        onTradeClickHandler(item);
                        return;
                      }
                    }}
                  >
                    {user?.current_amount < item.coins_value
                      ? 'GET COINS'
                      : item.is_sold_out
                      ? 'SOLD OUT'
                      : item.quantity === 0
                      ? 'SOLD OUT'
                      : item.quantity > 0
                      ? `TRADE`
                      : ''}
                  </Button>
                </Flex>
              </Flex>
            ))}
      </Grid>

      <TradeConfirmationModal
        isOpen={showConfirmModal}
        onCancel={handleCancelTrade}
        onConfirm={handleConfirmTrade}
        item={selectedItem}
      />
    </Flex>
  );
};

export default StorePage;
